module.exports = __webpack_public_path__ + "static/media/COPING_MIXED_DODGING.38f89e3f.md";